var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-copyright-area"},[_c('div',[_vm._v(" © "+_vm._s(new Date().getFullYear())+" CorporateGift.com. All Rights Reserved. ")]),_c('a',{attrs:{"href":"http://www.saydigitaldesign.com/","target":"_blank"}},[_vm._v("Design by Say Digital Design")])])
}
var staticRenderFns = []

export { render, staticRenderFns }